import React from "react";
import Root from "./components/Root";
import Tab from "./components/Tab";
import TabContent from "./components/TabContent";
import { BaseTabsList, BaseTabsListContainer } from "./components/TabsList";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Tabs(_ref) {
  var _tabsData$;
  var additionalActions = _ref.additionalActions,
    tabAlignment = _ref.tabAlignment,
    tabsData = _ref.tabsData,
    tabListAriaLabel = _ref.tabListAriaLabel,
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onValueChange = _ref.onValueChange,
    orientation = _ref.orientation,
    dir = _ref.dir,
    activationMode = _ref.activationMode;
  return /*#__PURE__*/_jsxs(Root, {
    defaultValue: defaultValue || ((_tabsData$ = tabsData[0]) === null || _tabsData$ === void 0 ? void 0 : _tabsData$.value),
    value: value,
    onValueChange: onValueChange,
    orientation: orientation,
    dir: dir,
    activationMode: activationMode,
    children: [/*#__PURE__*/_jsxs(BaseTabsListContainer, {
      children: [/*#__PURE__*/_jsx(BaseTabsList, {
        tabAlignment: tabAlignment,
        "aria-label": tabListAriaLabel,
        children: tabsData.map(function (_ref2) {
          var tabValue = _ref2.value,
            label = _ref2.label,
            disabled = _ref2.disabled;
          return /*#__PURE__*/_jsx(Tab, {
            value: tabValue,
            disabled: disabled,
            children: label
          }, tabValue);
        })
      }), additionalActions]
    }), tabsData.map(function (_ref3) {
      var tabValue = _ref3.value,
        contentRenderer = _ref3.contentRenderer;
      return /*#__PURE__*/_jsx(TabContent, {
        value: tabValue,
        children: contentRenderer(tabsData)
      }, tabValue);
    })]
  });
}
export default Tabs;